import { render } from "./SelectIngredientModal.vue?vue&type=template&id=f7932db8"
import script from "./SelectIngredientModal.vue?vue&type=script&lang=js"
export * from "./SelectIngredientModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__